module.exports = __webpack_public_path__ + "img/truck-hanging.9c79669d.svg";